const warnAboutUnavailableViewerId = () => {
    console.warn(
        '[Bootstrap] getViewerId was called, but user is not authorized.',
    );
};

export const maybeWrongMethodWarn = (viewerId: string) => {
    if (!viewerId) {
        warnAboutUnavailableViewerId();
    }
};
